import React, {Component} from 'react';
import {Field} from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Date from '../dates/dateHelpers';
import DateRange from '../dates/dateRange';
import * as Buttons from '../ui/buttons';

export default class CertificateForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const { personId, initialize, id, name, url, authority, license_number, start_date, end_date, person_id, data } = this.props;
        
        const startMonth = Date.handleDates(start_date, end_date).startMonth;
        const endMonth = Date.handleDates(start_date, end_date).endMonth;
        const initialValues = {
            "person_id": ( data && data.personId ) || +personId || +person_id,
            "id": id,
            "type": id ? "UPDATE" : "CREATE",
            "name": name,
            "authority": authority,
            "url": id && url,
            "license_number": license_number,
            "start_month": {label: startMonth && startMonth.name, value: startMonth && startMonth.id },
            "start_year": {label: (Date.handleDates(start_date, end_date).startYear), value: (Date.handleDates(start_date, end_date).startYear) },
            "end_month": {label: endMonth && endMonth.name, value: endMonth && endMonth.id},
            "end_year": {label: (Date.handleDates(start_date, end_date).endYear), value: (Date.handleDates(start_date, end_date).endYear) },
        };
        initialize(initialValues);
    };
    

    render() {
        const { buttonHandlers, start_date, end_date, onCancel, handleAdding } = this.props;
          const numberButtons = 3;
      const typeOfReq = this.props.id ? "UPDATE" : "CREATE";

        return (
            <form className="form-standard-profile">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Name"
                            name="name"
                            placeholder="Name"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Authority"
                            name="authority"
                            placeholder="Authority"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="License Number"
                            name="license_number"
                            placeholder="Licence Number"
                            component={ Form.textField }
                        />
                    </div>

                    <DateRange type={typeOfReq}
                               typeOf="study"
                               start_date={start_date}
                               end_date={end_date}/>

                    <div className="col-xs-12">
                        <Field
                            label="Url"
                            name="url"
                            placeholder="http://www....."
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12">
                        <Buttons.HOCFormButtons
                            { ... this.props }
                            onCancel={ () => onCancel () }
                            handleAdding={ ( form ) => handleAdding ( form ) }
                            { ...buttonHandlers }
                            numberButtons={ numberButtons }
                        />
                    </div>
                </div>
            </form>
        )
    }
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/CertificateForm.js